"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessWeekDays = exports.Weekday = void 0;
// Surely we have an existing type for this in gearbox somewhere
var Weekday;
(function (Weekday) {
    Weekday["MON"] = "monday";
    Weekday["TUE"] = "tuesday";
    Weekday["WED"] = "wednesday";
    Weekday["THU"] = "thursday";
    Weekday["FRI"] = "friday";
    Weekday["SAT"] = "saturday";
    Weekday["SUN"] = "sunday";
})(Weekday = exports.Weekday || (exports.Weekday = {}));
exports.BusinessWeekDays = [Weekday.MON, Weekday.TUE, Weekday.WED, Weekday.THU, Weekday.FRI];
__exportStar(require("./functions"), exports);
__exportStar(require("./platform-data/Calendars"), exports);
__exportStar(require("./platform-data/Events"), exports);
__exportStar(require("./platform-data/InviteLinks"), exports);
__exportStar(require("./platform-data/ReferralLinks"), exports);
__exportStar(require("./platform-data/Meetings"), exports);
__exportStar(require("./platform-data/Userspaces"), exports);
// export * from './platform-data/MeetingRequests'
__exportStar(require("./platform-data/FinancialUserspaces"), exports);
__exportStar(require("./platform-data/Transactions"), exports);
__exportStar(require("./platform-data/LoginTokens"), exports);
__exportStar(require("./platform-data/PaymentMethods"), exports);
//# sourceMappingURL=index.js.map